module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "generalinfo"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-766d4dc6!./src/components/generalinfo/template.html
// module id = 3889
// module chunks = 1